import { Outlet } from 'react-router'
import Header from '../../../component/layout/header'
import useNav from '../../../component/custom-hooks/get-nav';

const ComparisionLayout = () => {

  const navList = useNav();
  let {ComparisionTopNav, ComparisionBottomNav} = navList;

  return (
    <div className="webBody">
      <Header bottomTabs={ComparisionBottomNav} topTabs={ComparisionTopNav} />
      <Outlet />
    </div>
  )
}

export default ComparisionLayout